/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type IssueCountProps = {
	startIssueRange: number;
	endIssueRange: number;
	total: number;
};

export const IssueCount = ({ startIssueRange, endIssueRange, total }: IssueCountProps) => {
	const { formatMessage } = useIntl();

	return (
		<div
			css={issueCountContainerStyles}
			data-testid="issue-archival-archives.ui.archives-table.footer-renderer.issue-count-renderer.issue-count.issue-count"
		>
			{total <= 0
				? formatMessage(messages.issueRangeUnknown, {
						startIssueRange: 0,
						endIssueRange: 0,
					})
				: formatMessage(messages.issueRangeKnown, {
						startIssueRange,
						endIssueRange,
						totalNumberIssues: total,
					})}
		</div>
	);
};

const issueCountContainerStyles = css({
	display: 'flex',
	flex: 1,
	alignItems: 'center',
	justifyContent: 'center',
});
